import { c as _c } from "react/compiler-runtime";
import { Box, Divider } from '@mui/material';
import { MAXIMUM_COLUMNS_MOBILE, useCreditCardCompareColumnContext } from '../ColumnContext';
import { AnnualFeeContainer } from '../DetailSections/AnnualFee.container';
import { BonusOfferContainer } from '../DetailSections/BonusOffer.container';
import { ConsContainer } from '../DetailSections/Cons.container';
import { GreatForContainer } from '../DetailSections/GreatFor.container';
import { IntroAPRContainer } from '../DetailSections/IntroAPR.container';
import { OngoingAPRContainer } from '../DetailSections/OngoingAPR.container';
import { ProsContainer } from '../DetailSections/Pros.container';
import { RewardsRateContainer } from '../DetailSections/RewardsRate.container';
import { Observer } from '../ProductCardWithStickyHeader/components/Observer';
import { ProductCardObserverContainer } from '../ProductCardWithStickyHeader/ProductCard/ProductCardObserver.container';
import { StickyHeaderContainer } from '../ProductCardWithStickyHeader/StickyHeader/StickyHeader.container';
import { ApplyNowSkeleton } from './ApplyNow.skeleton';
import { CardAndTitleSkeleton } from './CardAndTitle.skeleton';
import { DetailSectionContentSkeleton } from './components/DetailSectionContent';
import { RatingSkeleton } from './Rating.skeleton';
import { RecommendedCreditScoreDesktopSkeleton } from './RecommendedCreditScoreDesktop.skeleton';
import { RecommendedCreditScoreMobileSkeleton } from './RecommendedCreditScoreMobile.skeleton';
import { StickyHeaderDesktopSkeleton } from './StickyHeaderDesktop.skeleton';
import { StickyHeaderMobileSkeleton } from './StickyHeaderMobile.skeleton';
export function ColumnSkeleton() {
  const $ = _c(24);
  const {
    index
  } = useCreditCardCompareColumnContext();
  const t0 = `credit-card-compare-sticky-header-skeleton-desktop-${index}`;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <StickyHeaderDesktopSkeleton />;
    t2 = <StickyHeaderMobileSkeleton />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t0) {
    t3 = <StickyHeaderContainer customDataTestId={t0}>{t1}{t2}</StickyHeaderContainer>;
    $[2] = t0;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = index > MAXIMUM_COLUMNS_MOBILE - 1 ? "none" : "contents";
  let t5;
  if ($[4] !== t4) {
    t5 = {
      xs: t4,
      md: "flex"
    };
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      xs: "flex",
      md: "contents"
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Box display={t6} flexDirection="column" flex={1}><ProductCardObserverContainer><Observer><CardAndTitleSkeleton /></Observer></ProductCardObserverContainer><RatingSkeleton /><ApplyNowSkeleton /></Box>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t10;
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Divider sx={{
      display: "block",
      borderColor: "neutral.lighter",
      mx: 3
    }} />;
    t9 = <RecommendedCreditScoreDesktopSkeleton />;
    t10 = <RecommendedCreditScoreMobileSkeleton />;
    $[8] = t10;
    $[9] = t8;
    $[10] = t9;
  } else {
    t10 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t11;
  if ($[11] !== t5) {
    t11 = <Box display={t5} flexDirection="column">{t7}{t8}{t9}{t10}</Box>;
    $[11] = t5;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <GreatForContainer><DetailSectionContentSkeleton /></GreatForContainer>;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <AnnualFeeContainer><DetailSectionContentSkeleton /></AnnualFeeContainer>;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <BonusOfferContainer><DetailSectionContentSkeleton /></BonusOfferContainer>;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <RewardsRateContainer><DetailSectionContentSkeleton /></RewardsRateContainer>;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <IntroAPRContainer><DetailSectionContentSkeleton /></IntroAPRContainer>;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <OngoingAPRContainer><DetailSectionContentSkeleton /></OngoingAPRContainer>;
    $[18] = t17;
  } else {
    t17 = $[18];
  }
  let t18;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <ProsContainer><DetailSectionContentSkeleton /></ProsContainer>;
    $[19] = t18;
  } else {
    t18 = $[19];
  }
  let t19;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <ConsContainer><DetailSectionContentSkeleton /></ConsContainer>;
    $[20] = t19;
  } else {
    t19 = $[20];
  }
  let t20;
  if ($[21] !== t11 || $[22] !== t3) {
    t20 = <>{t3}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t19}</>;
    $[21] = t11;
    $[22] = t3;
    $[23] = t20;
  } else {
    t20 = $[23];
  }
  return t20;
}